/* eslint-disable camelcase */
import { AxiosResponse } from 'axios';
import { useMfaLabels } from 'client/util/Constants/MfaLabels';
import RequestError from 'client/services/response/RequestError';
import loadDuoScript from 'client/containers/user/MfaComponents/mfaUtils/loadDuoScript';
import userLoginService from 'client/services/userLoginService';

const uiLabel = useMfaLabels();

const initDuo = (host: string, sig_request: string, submit_callback: DuoCallback): void => {
  if (window && window.Duo) {
    const params: DuoInitParams = {
      host,
      sig_request,
      submit_callback,
    };

    window.Duo.init(params);
  }
};

const handleScriptLoaded = (duoInfo: DuoChallenge, callback: DuoCallback): string => {
  const { api_host, sig_request, token } = duoInfo;
  initDuo(api_host, sig_request, callback);

  return token;
};

export const shouldLoadScript = (): boolean => (
  document.getElementById('duo_security') === null
);

// eslint-disable-next-line max-len
const parseDuoInfo = async (response: AxiosResponse, callback: DuoCallback): Promise <string> => {
  try {
  // only load Duo script if it hasn't been done before
    if (shouldLoadScript()) {
      await loadDuoScript();
    }
    return handleScriptLoaded(response.data, callback);
  } catch {
    throw uiLabel.duo.error.load;
  }
};

export default {
  async setUpDuoForLogin(callback: DuoCallback): Promise<string> {
    try {
      const response = await userLoginService.getDuoInfo();

      return await parseDuoInfo(response, callback);
    } catch {
      throw new RequestError(0, uiLabel.duo.error.load);
    }
  },

  async setUpDuoForPasswordReset(challenge: DuoChallenge, callback: DuoCallback): Promise<string> {
    try {
      // only load Duo script if it hasn't been done before
      if (shouldLoadScript()) {
        await loadDuoScript();
      }

      return handleScriptLoaded(challenge, callback);
    } catch {
      throw new RequestError(0, uiLabel.duo.error.load);
    }
  },
};
